import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';


@Component({
  selector: 'app-timekeeping',
  templateUrl: './timekeeping.component.html',
  styleUrls: ['./timekeeping.component.less']
})
export class TimekeepingComponent implements OnInit {
  isCollapsed = false;
  currentUserId = JSON.parse(localStorage.getItem("currentUser")).user.employee._id;
  timeKeepingData: any = [];
  
  getTimekeeping(){
    const today: Date = new Date();
    const yyyy: string = today.getFullYear().toString();
    const mmfrom: string = (today.getMonth()).toString().padStart(2, '0');
    const mmto: string = (today.getMonth() + 2).toString().padStart(2, '0');

    this.userService.getTimekeeping(this.currentUserId, `${yyyy}-${mmfrom}-01`, `${yyyy}-${mmto}-31`).subscribe((res:any)=>{
      console.log('res', res);
      this.timeKeepingData = res.data.data;
    });
  }

  selectChange(event: Date): void {
    const selectedMonth: number = event.getMonth();
    const selectedYear: number = event.getFullYear();
  
    let from: string = `${selectedYear}-${selectedMonth}-01`;
    let to: string = `${selectedYear}-${selectedMonth + 2}-31`;
  
    if (selectedMonth === 0) {
      from = `${selectedYear - 1}-12-01`;
    } else if (selectedMonth === 11) {
      to = `${selectedYear + 1}-01-31`;
    }
  
    this.userService.getTimekeeping(this.currentUserId, from, to).subscribe((res: any) => {
      console.log('res', res);
      this.timeKeepingData = res.data.data;
    });
  }

  isSameDay(dateString: string, selectedDate: Date): boolean {
    const date = new Date(dateString);
    return date.getFullYear() === selectedDate.getFullYear() &&
      date.getMonth() === selectedDate.getMonth() &&
      date.getDate() === selectedDate.getDate();
  }

  constructor(
    private userService:UserService,
  ) { }

  ngOnInit() {
    this.getTimekeeping();
  }

}
